// extracted by mini-css-extract-plugin
module.exports = {"pc":"style-module--pc--2wS29","bc":"style-module--bc--3VzL3","dashboard":"style-module--dashboard--39K91","bold":"style-module--bold--1Drq-"};